import React, { useEffect, useState } from 'react';
import GeneralGoal from './GeneralGoal';
import TableCoins from './TableCoins';
import TargetCoins from './TargetCoins';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import {
  IMonthlyCoins,
  IMonthlyGoal
} from '../../../../store/ducks/loyalty/types';

const LoyaltyHasCoins: React.FC = () => {
  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);
  const [selectedMonthIdx, setSelectedMonthIdx] = useState(0);

  const [selectedRewardMonth, setSelectedRewardMonth] = useState<
    IMonthlyCoins | undefined
  >(loyalty.rewards.monthly_coins[selectedMonthIdx]);

  const [selectedGoalMonth, setSelectedGoalMonth] = useState<
    IMonthlyGoal | undefined
  >(loyalty.goal.monthly_goal[selectedMonthIdx]);

  useEffect(() => {
    setSelectedRewardMonth(loyalty.rewards.monthly_coins[selectedMonthIdx]);
    setSelectedGoalMonth(loyalty.goal.monthly_goal[selectedMonthIdx]);
  }, [selectedMonthIdx, loyalty.goal.loading, loyalty.rewards.loading]);

  return (
    <div>
      <TargetCoins
        selectedMonthIdx={selectedMonthIdx}
        onChangeSelectedMonthIdx={(newIdx) => setSelectedMonthIdx(newIdx)}
        selectedGoalMonth={selectedGoalMonth}
        selectedRewardMonth={selectedRewardMonth}
      />
      <GeneralGoal
        selectedRewardMonth={selectedRewardMonth}
        selectedGoalMonth={selectedGoalMonth}
      />
      <TableCoins />
    </div>
  );
};

export default LoyaltyHasCoins;
